function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleGroupOfPeopleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.572 15.83a2.814 2.814 0 00-2.823 2.823v7.524H21.2v-7.524a2.814 2.814 0 00-2.823-2.823h-4.804zm-4.823 2.823a4.814 4.814 0 014.823-4.823h4.804a4.814 4.814 0 014.823 4.823v8.524a1 1 0 01-1 1H9.75a1 1 0 01-1-1v-8.524zM16 5.033a2.823 2.823 0 100 5.646 2.823 2.823 0 000-5.646zm-4.823 2.823a4.823 4.823 0 119.646 0 4.823 4.823 0 01-9.646 0zM7.373 7.89a3.376 3.376 0 100 6.752 3.376 3.376 0 000-6.753zm-1.377 3.375a1.376 1.376 0 112.753 0 1.376 1.376 0 01-2.753 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.033 19.583c0-.946.792-1.738 1.738-1.738h3.41c.22 0 .433.043.629.121a3.803 3.803 0 01.86-1.808 3.69 3.69 0 00-1.49-.313H5.772a3.756 3.756 0 00-3.738 3.738v5.94a1 1 0 001 1H9.75v-2H4.033v-4.94zM22.2 26.524h6.715a1 1 0 001-1v-5.941a3.756 3.756 0 00-3.738-3.738h-3.41c-.528 0-1.032.112-1.49.313.434.505.738 1.124.861 1.808.196-.078.409-.121.63-.121h3.41c.945 0 1.737.792 1.737 1.738v4.94H22.2v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.627 7.89a3.376 3.376 0 100 6.752 3.376 3.376 0 000-6.753zm-1.376 3.375a1.376 1.376 0 112.753 0 1.376 1.376 0 01-2.753 0z",
    fill: props.color
  }));
}

export default SvgIconPeopleGroupOfPeopleFilled;